import React, { type ReactElement } from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@ndd/ui";
import type { RdScheduleRepeatInterval } from "../../../../../shared/rd-schedule-actions";

// NO-876. The Repeats choice in New appointment: one visit, or a weekly,
// two-weekly or four-weekly series.

export function RepeatSelect(props: {
  id: string;
  value: RdScheduleRepeatInterval | "none";
  labels: Record<RdScheduleRepeatInterval, string>;
  disabled: boolean;
  onChange: (value: RdScheduleRepeatInterval | "none") => void;
}): ReactElement {
  return (
    <Select
      value={props.value}
      disabled={props.disabled}
      onValueChange={(next) =>
        props.onChange(next as RdScheduleRepeatInterval | "none")
      }
    >
      <SelectTrigger id={props.id}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="none">Does not repeat</SelectItem>
        {(Object.keys(props.labels) as RdScheduleRepeatInterval[]).map((interval) => (
          <SelectItem key={interval} value={interval}>
            {props.labels[interval]}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
